// extracted by mini-css-extract-plugin
export default {"container":"StackedBar_container__Xe-Az","bar":"StackedBar_bar__0rW4B","bar--animate-in":"StackedBar_bar--animate-in__ybiak","bar__portion":"StackedBar_bar__portion__bjzIw"};